// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2915) return "static/chunks/2915-f6821371.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 998 ? "b2ccfc24" : chunkId) + "." + {"998":"7feebf4432ae5840","1827":"39ad08b966578cea","4451":"0050db0b6221a407","7169":"517828a7f2ecc49a","9694":"5a4099ce8a321878"}[chunkId] + ".js";
};